import { render, staticRenderFns } from "./CorrectorManagerForm.vue?vue&type=template&id=231b4a9e&"
import script from "./CorrectorManagerForm.vue?vue&type=script&lang=ts&"
export * from "./CorrectorManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports